// libraries
import React from "react";
import { Dropdown, Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import moment from "moment";

// redux
import { connect } from "react-redux";

// components
import Input from "@Components/Input";
import IKModal from "@Components/IkModal";
import Text from "@Components/Text";

// utils
// import { getTimeLabel } from "@Utils/index";

// styles
import styles from "./styles.module.css";

const FilterForm = ({ onFilter, onClose, agent, estado, fechaEstado, setAgent, setEstado, setFechaEstado, stateOptions, isUserAction }) => {
	const handleClear = () => {
		setAgent("");
		setEstado([]);
		setFechaEstado("");
		onFilter({});
	};

	const handlerFilter = () => {
		const isValidDate = moment(fechaEstado).isValid();

		const params = {
			"lastLog.state": estado,
			"lastLog.startDate": isValidDate ? moment(fechaEstado).format("YYYY-MM-DD") : "",
			"user.fullName": agent,
		};

		onFilter(params);
		onClose();
	};
	return (
		<IKModal
			iconName="filter"
			title="Filtrar Estados Agentes"
			saveLabel="Buscar"
			noMode
			onClose={onClose}
			onSuccess={handlerFilter}
			fullHeight
			size="tiny"
			headerButtons={[
				<div className={styles.headerButtons}>
					<Button
						className={styles.clean}
						icon="trash"
						onClick={() => {
							handleClear();
						}}>
						Limpiar
					</Button>
				</div>,
			]}>
			<div className={styles.container}>
				<div className={styles.rowColumn}>
					<div className={styles.rowColumn2}>
						<Text className={styles.label}>Estado:</Text>
						<Dropdown
							placeholder="Selecciona un estado"
							fluid
							search
							selection
							options={stateOptions}
							value={estado}
							onChange={(e, { value }) => {
								return setEstado(value);
							}}
							multiple
							clearable
						/>
					</div>

					<div className={styles.rowColumn2}>
						<Text className={styles.label}>Fecha:</Text>
						<Input
							type="date"
							icon="calendar"
							iconPosition="left"
							placeholder="Fecha Estado"
							value={fechaEstado}
							onChange={(e) => {
								return setFechaEstado(e.target.value);
							}}
							max={moment().format("YYYY-MM-DD")}
						/>
					</div>

					{!isUserAction && (
						<div className={styles.rowColumn2}>
							<Text className={styles.label}>Agente:</Text>
							<Input
								icon="user"
								iconPosition="left"
								placeholder="Nombre del Agente"
								value={agent}
								onChange={(e) => {
									return setAgent(e.target.value);
								}}
							/>
						</div>
					)}
				</div>
			</div>
		</IKModal>
	);
};

FilterForm.propTypes = {
	onFilter: PropTypes.func,
	onClose: PropTypes.func,
	agent: PropTypes.string,
	estado: PropTypes.string,
	fechaEstado: PropTypes.string,
	setAgent: PropTypes.func,
	setEstado: PropTypes.func,
	setFechaEstado: PropTypes.func,
	stateOptions: PropTypes.array,
	isUserAction: PropTypes.bool,
};

function mapStateToProps() {
	return {};
}
export default connect(mapStateToProps)(FilterForm);
